import PropTypes from "prop-types";
import React from "react";

import InfoIcon from "@mui/icons-material/Info";
import { Button } from "@mui/material";

import { centerVericalAlignIconStyle, overflowButtonStyle } from "../../../helpers/styles";

const buttonStyle = {
    ...overflowButtonStyle,
    minHeight: "2rem",
    height: "auto",
    whiteSpace: "normal",
};

function InfoButton(props) {
    return (
        <Button
            fullWidth
            variant="contained"
            size="small"
            endIcon={<InfoIcon sx={centerVericalAlignIconStyle} />}
            onClick={props.onClick}
            sx={buttonStyle}
        >
            {props.label}
        </Button>
    );
}

InfoButton.propTypes = {
    label: PropTypes.string,
};

export default InfoButton;
